export const isFinishedReport = (status) => {
  const s = (status || '').toLowerCase();

  return s === 'finished' || s === 'canceled';
};
